import { FC, Fragment } from 'react'
import { FormDataConsumer, SelectInput, required } from 'react-admin'
import CertificatesInterfaceSelect from './ZakenCertificatesInterfaceSelect'

export const CertificatesCreateZaakClient: FC = () => (
  <Fragment>
    <SelectInput
      source="metaData.samlKoppeling"
      label="resources.certificates.fields.samlKoppeling"
      choices={[
        { id: 'samlidp', name: 'resources.certificates.fields.samlidp' },
        { id: 'stuf_dcr', name: 'resources.certificates.fields.stuf_dcr' },
        { id: 'stuf_zkn_client', name: 'resources.certificates.fields.stuf_zkn_client' },
        { id: 'stufconfig', name: 'resources.certificates.fields.stufconfig' },
        { id: 'xential', name: 'resources.certificates.fields.xential' },
        { id: 'api', name: 'resources.certificates.fields.api' },
        { id: 'event_sink', name: 'resources.certificates.fields.event_sink' },
        { id: 'export_queue', name: 'resources.certificates.fields.export_queue' },
        { id: 'gws4all', name: 'resources.certificates.fields.gws4all' },
      ]}
      helperText="resources.certificates.fields.samlKoppeling_help"
      fullWidth
      validate={[required()]}
    />
    <FormDataConsumer>
      {({ formData }: { formData: { metaData?: { instanceId?: string; samlKoppeling?: string } } }) =>
        formData.metaData?.samlKoppeling && (
        <CertificatesInterfaceSelect
            instanceId={formData.metaData.instanceId}
            module={formData.metaData.samlKoppeling}
          />
      )}
    </FormDataConsumer>
  </Fragment>
)